import { FormattedMessage, useIntl } from 'react-intl';

import type { TextButtonSizes } from '@xing-com/button';
import { IconBookmark, IconBookmarkFilled } from '@xing-com/icons';

import * as S from './action-buttons.styles';

type Props = {
  isBookmarked?: boolean;
  iconsOnly?: boolean;
  iconsAfter?: boolean;
  bottom?: boolean;
  top?: boolean;
  onBookmark?: () => void;
  size?: TextButtonSizes;
  noMargin?: boolean;
  className?: string;
};

export const ActionButtons: React.FC<Props> = ({
  isBookmarked,
  iconsOnly,
  iconsAfter,
  bottom,
  top,
  onBookmark,
  size = 'medium',
  noMargin = false,
  className,
}) => {
  const { formatMessage } = useIntl();

  const handleOnBookmark = (event: React.MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();

    onBookmark?.();
  };

  return (
    <S.ActionButtons
      $isBottom={bottom}
      $isTop={top}
      $noMargin={noMargin}
      className={className}
    >
      {onBookmark ? (
        <S.Button
          size={size}
          icon={isBookmarked ? IconBookmarkFilled : IconBookmark}
          iconAfter={iconsAfter}
          onClick={handleOnBookmark}
          fontWeight="regular"
          data-testid={
            isBookmarked
              ? 'bookmark-action-button-filled'
              : 'bookmark-action-button'
          }
          aria-label={
            iconsOnly
              ? isBookmarked
                ? formatMessage({ id: 'JOBS_JOB_TEASER_SAVED' })
                : formatMessage({ id: 'JOBS_JOB_TEASER_SAVE' })
              : undefined
          }
        >
          {iconsOnly ? null : isBookmarked ? (
            <FormattedMessage id="JOBS_JOB_TEASER_SAVED" />
          ) : (
            <FormattedMessage id="JOBS_JOB_TEASER_SAVE" />
          )}
        </S.Button>
      ) : null}
    </S.ActionButtons>
  );
};
